import { formatDate } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Timestamp } from '@marmon/shared/types/common';

@Pipe({ name: 'timestamp' })
export class TimestampPipe implements PipeTransform {
	private readonly locale = inject(LOCALE_ID);

	transform(timestamp: Timestamp, timezone?: string) {
		return formatDate(
			timestamp.toDate(),
			'mediumDate',
			this.locale,
			timezone ?? undefined,
		);
	}
}
